/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-south-1",
    "aws_cognito_identity_pool_id": "ap-south-1:448b4746-5f25-4010-806c-e326f2c11d06",
    "aws_cognito_region": "ap-south-1",
    "aws_user_pools_id": "ap-south-1_oL89Eq0lT",
    "aws_user_pools_web_client_id": "41qqoopdkn99s8vii110r4pk25",
    "oauth": {},
    "aws_cognito_login_mechanisms": [
        "EMAIL",
        "PREFERRED_USERNAME"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_appsync_graphqlEndpoint": "https://gztmihemyzht3eei6eixec4lme.appsync-api.ap-south-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-south-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-t4i5ajwx5zdg3k44gqjw7tshom",
    "aws_user_files_s3_bucket": "bookify11c182b0793c427584fc6d2f4927e7e3173820-bookify",
    "aws_user_files_s3_bucket_region": "ap-south-1"
};


export default awsmobile;
